module.exports = __webpack_public_path__ + "img/IMAGE 6.46d750ae.png";